import { CurrencyFormat, formatCurrencySuffix } from "common/lib/currency";
import {
  getTotalPaymentsAmount,
  getTotalPaymentsCount,
} from "common/services/payments.service";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { setLoading } from "slices/search/reducer";

const TotalSupportWidget = ({ activeTab }: { activeTab: string }) => {
  const [totalSupport, setTotalSupport] = useState<CurrencyFormat>({
    amount: 0,
    suffix: "",
    formattedString: "",
    exactAmount: 0,
  });
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        if (activeTab === "amount") {
          const response: any = await getTotalPaymentsAmount({});
          setTotalSupport(formatCurrencySuffix(response?.totalAmount));
        } else if (activeTab === "number") {
          const response: any = await getTotalPaymentsCount({});
          setTotalCount(response?.totalCount || 0);
        }
      } catch (error) {
        console.warn("Error fetching total support data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [activeTab]);

  return (
    <div className="p-3 border border-dashed border-start-0">
      <h5 className="mb-1">
        {activeTab === "amount" ? (
          <span
            className="counter-value"
            data-target={`${totalSupport?.amount}`}
          >
            <CountUp
              start={0}
              end={totalSupport?.amount}
              decimals={2}
              suffix={totalSupport?.suffix}
              duration={1}
            />
          </span>
        ) : (
          <span className="counter-value" data-target={`${totalCount}`}>
            <CountUp
              start={0}
              end={totalCount}
              decimals={0}
              separator=","
              duration={1}
            />
          </span>
        )}
      </h5>
      <p className="text-muted mb-0">
        {activeTab === "amount"
          ? "Total Cumulative Support"
          : "Total Number of Contracts"}
      </p>
    </div>
  );
};

export default TotalSupportWidget;
